import { DefaultErrorFormSummaryComponent } from "./components/error-form-summary/templates/default-error-form-summary/default-error-form-summary.component";

export const formComponentDef = {
    "error-form-summary": {
        "default": DefaultErrorFormSummaryComponent,
        "social": DefaultErrorFormSummaryComponent,
        "sky": DefaultErrorFormSummaryComponent
    }
}